import React, { useEffect, useMemo, useState } from 'react'
import cn from 'classnames'
import styles from './Withdraw.module.sass'
import Icon from '../Icon'
import TextInput from '../TextInput'
import Successfully from './Successfully'
import DropdownCoins from 'components/DropdownCoins'
import DropdownDynamic from 'components/DropdownDynamic'
import { addWithdrawCrypto } from 'apis/withdraw'
import Loader from 'components/Loader'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { fetchReferenceCurrency } from 'store/actions'

// Array of allowed currency IDs - replace with your specific IDs
const ALLOWED_CURRENCIES = ['USDT', 'BTC', 'ETH'] 

const Withdraw = () => {
  const [selectedCurrency, setSelectedCurrency] = useState()
  const [feesAmount, setFeesAmount] = useState()
  const [responseData, setResponseData] = useState([])
  const [walletsOptions, setWalletsOptions] = useState([])
  const [filteredCurrencies, setFilteredCurrencies] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [visibleWithdraw, setVisibleWithdraw] = useState(true)
  const [visibleSuccessfully, setVisibleSuccessfully] = useState(false)
  const [address, setAddress] = useState('')
  const [coin, setCoin] = useState('')
  const [transactionFees, setTransactionFees] = useState(0)
  const [amount, setAmount] = useState()
  const [withdrawAmount, setWithdrawAmount] = useState()
  const [network, setNetwork] = useState('')
  const {exchangeWallets} = useSelector(state=>state?.walletReducer)

  const { clientData } = useSelector((state) => state?.Profile)
  const { referenceCurrency, referenceCurrencyLoading } = useSelector(state =>
     state.assets)

  // Filter and process reference currency data
  useEffect(() => {
    if (referenceCurrency && Array.isArray(referenceCurrency?.data)) {
      setFilteredCurrencies(referenceCurrency.data)
    }
  }, [referenceCurrency])

  // Update available networks when coin changes
  useEffect(() => {

      if (selectedCurrency) {
        // Map networks from reference currency to match your network structure
        const availableNetworks = selectedCurrency?.chains?.map(network => ({
          _id: `${network?.displayName}-${network?.chain}-${Math.floor(Math.random() * 1000)}`,
          name: network?.displayName,
          chainId: {
            _id: `${network?.displayName}-${network?.chain}-${Math.floor(Math.random() * 1000)}`,
            name: network?.displayName,
            cryptoapiName: network?.chain,
            ...network
          },
          address: network?.address || ''
        }))
        
        // Update coin networks with reference currency networks
        setCoin(prev => ({
          ...prev,
          networks: availableNetworks
        }))
      }
    // }
  }, [selectedCurrency])

  const filteredWallets = useMemo(() => {
    if (!exchangeWallets || !filteredCurrencies?.length) return [];
    
    return exchangeWallets.filter(wallet =>
      filteredCurrencies.some(curr => curr?.currency?.toUpperCase() === wallet.asset?.toUpperCase())
    );
  }, [exchangeWallets, filteredCurrencies]);

  useEffect(() => {
    setWalletsOptions((prevWallets) => {
      if (JSON.stringify(prevWallets) !== JSON.stringify(filteredWallets)) {
        return filteredWallets;
      }
      return prevWallets; // No update if data is unchanged
    });
  }, [filteredWallets]);
  console.log("logs development", {
    exchangeWallets,
    referenceCurrency,
    filteredCurrencies,
    filteredWallets,
    walletsOptions,
    feesAmount
  })
  useEffect(() => {
    setAmount(coin?.amount)
    const selectedCurrencyItem = referenceCurrency?.data?.find(
      curr => curr?.currency?.toUpperCase() === coin?.asset?.toUpperCase()
    )
    setSelectedCurrency(selectedCurrencyItem);
  }, [coin])

  useEffect(() => {
    setTransactionFees(network?.chainId?.transactFeeWithdraw)
  }, [network])

  function validateInputs() {
    let status = true
    if (!coin) {
      toast.error('Coin Is Required')
      status = false
    }
    if (!network) {
      toast.error('Network Is Required')
      status = false
    }
    if (!withdrawAmount) {
      toast.error('Withdraw Amount Is Required')
      status = false
    }
    if (!address) {
      toast.error('Address Is Required')
      status = false
    }
    return status
  }

  const sendData = async () => {
    try {
      if (!validateInputs()) {
        return
      }
      setIsLoading(true)
      
      const fromAddress = clientData?.htx?.depositAddresses?.find(address => 
        address?.chain === network?.chainId?.chain
      )
      const sendedData = {
        to: address,
        walletId: coin?._id,
        amountBeforeFees: Number(withdrawAmount),
        amount: (Number(transactionFees) || 0) + (Number(feesAmount) || 0) + Number(withdrawAmount),
        assetId: coin?.assetId,
        asset:coin?.asset,
        chainId: network?.chainId?.chain,
        addressId: network?._id,
        note: "note",
        htxFeesAmount: transactionFees,
        networkName: network?.chainId?.fullName.charAt(0).toUpperCase() + network?.chainId?.fullName.slice(1).toLowerCase(),
        cryptoapiName: network?.chainId?.fullName?.toLowerCase() ,
        from: fromAddress?.address
      }
      
      const data = await addWithdrawCrypto(sendedData)
      setResponseData(data?.result)
      setIsLoading(false)
      
      if (data?.isSuccess) {
        setVisibleWithdraw(false)
        setVisibleSuccessfully(true)
      }
      if (data?.isError) {
        toast.error(data?.message)
      }
    } catch (error) {
      console.error(error)
      toast.error('An error occurred while processing your withdrawal')
      setIsLoading(false)
    }
  }

  
  const handleCalculateFeesValue = (value) =>{
    let fee = 0
    value = Number(value)
    const tradingFee = clientData?.transactionFeeId
    if (tradingFee?.isPercentage) {
      if (tradingFee?.assets?.[coin?.asset?.toUpperCase()]) {
        let feeValue = (tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.value / 100) * value
        if (feeValue > Number(tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.maxValue) ) {
          fee = Number(tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.maxValue)
        } else if (feeValue < Number(tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.minValue)) {
          fee = Number(tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.minValue)
        } else {
          fee = feeValue
        }
      } else {
        let feeValue = (tradingFee?.value?.$numberDecimal / 100) * value
        if (feeValue  > Number(tradingFee?.maxValue?.$numberDecimal) ) {
          fee = Number(tradingFee?.maxValue?.$numberDecimal)
        } else if (feeValue  < Number(tradingFee?.minValue?.$numberDecimal)) {
          fee = Number(tradingFee?.minValue?.$numberDecimal)
        } else {
          fee = feeValue
        }
      }
    } else {
      if (tradingFee?.assets?.[coin?.asset?.toUpperCase()]) {
        if (value > tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.maxValue ) {
          fee = tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.maxValue
        } else if (value < tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.minValue) {
          fee = tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.minValue
        } else {
          fee = tradingFee?.assets?.[coin?.asset?.toUpperCase()]?.value
        }
      } else {
        if (value > tradingFee?.maxValue?.$numberDecimal ) {
          fee = tradingFee?.maxValue?.$numberDecimal
        } else if (value < tradingFee?.minValue?.$numberDecimal) {
          fee = tradingFee?.minValue?.$numberDecimal
        } else {
          fee = tradingFee?.value?.$numberDecimal
        }
      }
    }
    console.log("feeeee", fee)
    setFeesAmount(fee)
  }

  const handleChangeAmountPrices = (value) =>{
    if (value) {
      // setTotalPrice(price * amount)
      setWithdrawAmount(value)
      handleCalculateFeesValue(value)
    }
  }

  return (
    <>
      {visibleWithdraw && (
        <div className={styles.withdraw}>
          <div className={cn('h4', styles.title)}>
            <Icon name="arrow-left" size="32" />
            Withdraw {coin?.assetId?.symbol || 'Crypto'}
          </div>
          
          <div>
            <label className={styles.label}>Coin/Wallet</label>
            <DropdownCoins
              className={styles.dropdown}
              classDropdownHead={styles.dropdownHead}
              value={coin}
              setValue={v=>
                setCoin({
                  ...v,
                   amount:exchangeWallets.find(wallet=>wallet.asset.toUpperCase()==v.asset.toUpperCase())?.balance,
                   assetId:exchangeWallets.find(wallet=>wallet.asset.toUpperCase()==v.asset.toUpperCase())?.assetId})}
              options={walletsOptions}
              disabled={referenceCurrencyLoading}
            />
          </div>

          <div>
            <label className={styles.label}>Network</label>
            <DropdownDynamic
              className={styles.dropdown}
              classDropdownHead={styles.dropdownHead}
              value={network}
              setValue={setNetwork}
              options={coin?.networks || []}
              uniqueName={'name'}
              uniqueId={'_id'}
              disabled={!coin || referenceCurrencyLoading}
            />
          </div>
          
          <TextInput
            className={styles.field}
            label="Address"
            name="address"
            type="text"
            note={`Do not send ${coin?.assetId?.symbol || 'crypto'} unless you are certain the destination supports ${network?.chainId?.displayName || 'the selected'} network transactions.`}
            onChange={(e) => setAddress(e?.target?.value)}
            value={address}
            required
          />

          <div className={styles.wrap}>
            <div className={styles.category}>
              Available balance
            </div>
            <div className={styles.details}>
              <div className={styles.currency}>
                {amount} {coin?.assetId?.symbol}
              </div>
            </div>
          </div>

          <div className={styles.box}>
            <TextInput
              className={styles.field}
              label="Amount to withdraw"
              name="amount"
              type="number"
              note="Subject to daily withdrawal limit"
              onChange={(e) => handleChangeAmountPrices(e.target.value)}
              value={withdrawAmount}
              required
            />
            <button 
              className={cn('button-stroke button-small', styles.button)}
              onClick={() => setWithdrawAmount(amount || 0)}
            >
              Max amount
            </button>
          </div>

          <TextInput
            className={styles.field}
            label="Network fee"
            name="transaction"
            type="number"
            value={(Number(transactionFees) || 0) + (Number(feesAmount) || 0)}
            disabled
          />

          <TextInput
            className={styles.field}
            label="Total"
            name="total"
            type="number"
            value={(Number(transactionFees) || 0) + (Number(feesAmount) || 0) + Number(withdrawAmount) }
            disabled
          />

          <button
            type="submit"
            disabled={isLoading || referenceCurrencyLoading}
            className={cn('button', styles.button)}
            onClick={sendData}
          >
            {isLoading || referenceCurrencyLoading ? <Loader /> : 'Withdraw'}
          </button>
        </div>
      )}
      
      {visibleSuccessfully && (
        <Successfully 
          responseData={responseData}
          handleClick={() => {
            setVisibleWithdraw(false)
            setVisibleSuccessfully(true)
          }}
        />
      )}
    </>
  )
}

export default Withdraw